import React from 'react';
import PropTypes from 'prop-types';
import {
  arrayOf, extend, shape, string, useDataModel, alias
} from '@thd-nucleus/data-sources';
import { RetailMediaCarousel } from '../RetailMediaCarousel';
import { dataModel as retailMediaCarouselDataModel } from '../RetailMediaCarousel/RetailMediaCarousel.dataModel';
import { useTheme } from '@thd-olt-component-react/theme-provider';

export const RetailMediaCarouselFusionPIP = (props) => {

  const { itemId, storeId, border } = props;

  const theme = useTheme(RetailMediaCarouselFusionPIP);
  const { hideRetailMediaCarousel } = theme.props;

  const variables = {
    itemId,
    storeId
  };

  const { data } = useDataModel('clientOnlyProduct', {
    skip: !itemId || hideRetailMediaCarousel,
    ssr: false,
    variables
  });

  if (hideRetailMediaCarousel) {
    return null;
  }

  return (
    <RetailMediaCarousel
      breadCrumbs={data?.product?.taxonomy?.breadCrumbs}
      pageContext={{
        schema: 'pip_sponsored',
        data: { itemId },
        isPip: true
      }}
      showSponsoredCarousel
      dynamic={{
        pageType: 'pip'
      }}
      hydrator={{
        className: 'sui-grid',
        tag: {
          className: 'sui-bg-primary sui-rounded-base sui-max-w-screen-2xl sui-w-full sui-overflow-hidden'
        },
        delay: 1500,
        scrollBuffer: 750
      }}
      border={border}
    />
  );
};

RetailMediaCarouselFusionPIP.displayName = 'RetailMediaCarouselFusionPIP';

RetailMediaCarouselFusionPIP.defaultProps = {
  storeId: undefined,
  border: false,
};

RetailMediaCarouselFusionPIP.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  border: PropTypes.bool,
};

RetailMediaCarouselFusionPIP.themeProps = {
  hideRetailMediaCarousel: PropTypes.bool
};

RetailMediaCarouselFusionPIP.defaultThemeProps = {
  hideRetailMediaCarousel: false
};

const BreadCrumbType = shape({
  browseUrl: string(),
  label: string()
});

RetailMediaCarouselFusionPIP.dataModel = extend({
  clientOnlyProduct: alias('product').params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSource: string(),
    taxonomy: shape({
      breadCrumbs: arrayOf(BreadCrumbType)
    })
  })
}, retailMediaCarouselDataModel);